import React from 'react';

import { colorGray } from 'styles/layout/colors';
import IconPlay2 from 'components/icons/iconPlay2';

const LivestreamPlayIcon = () => (
  <div className="items-center bg-white rounded-[32px] flex h-16 justify-center w-16">
    <IconPlay2 color={colorGray} className="LivestreamPlayIcon__icon" />
  </div>
);

export default LivestreamPlayIcon;
